import { AxiosPromise } from "axios";
import { MRT_PaginationState } from "material-react-table";
import {
  TDomesticBranchesParams,
  TGetDomesticBranchesResponse,
} from "src/business/types";
import { httpClient } from "src/shared/services/httpClient";

export const getFiles = (bid: string | null) =>
  httpClient.get(`/business/files${bid ? `?bid=${bid}` : ""}`);
export const getXbrlFiles = () => httpClient.get("/business/xbrlFiles");
export const deleteXbrlFile = (id: number, fileName: string) =>
  httpClient.delete(
    `/business/deleteXbrlFile?id=${id}&file=${encodeURIComponent(fileName)}`,
  );
export const deleteXhtmlFile = (fileName: string) =>
  httpClient.delete(
    `/business/deleteXhtmlFile?file=${encodeURIComponent(fileName)}`,
  );
export const uploadXBRLFile = (data: FormData) =>
  httpClient.post("/business/uploadXBRLFile", data);
export const getManageApplication = (id: string) =>
  httpClient.get(`/business/manageApplicationReact?appId=${id}`);
export const uploadFile = ({
  bid,
  selectedFile,
}: {
  bid?: string | null;
  selectedFile: File;
}) => {
  const formData = new FormData();
  formData.append("qqfile", selectedFile);
  return httpClient.post(
    `/business/uploadfile${bid ? `?bid=${bid}` : ""}`,
    formData,
  );
};
export type TDeleteFileResponse = {
  status: number;
  /** "ok" | "error" (in use by application/s) | "notFound" | "failed" */
  message: "ok" | "error" | "notFound" | "failed";
  applications?: { m02_id: number }[];
};
export const deleteFile = ({
  fileToDelete,
  bid,
}: {
  fileToDelete: {
    file: string;
    id: number;
    fileType: string;
  };
  bid: string | null;
}): AxiosPromise<TDeleteFileResponse> =>
  httpClient.delete<TDeleteFileResponse>(
    `/business/deletefile?file=${encodeURIComponent(fileToDelete.file)}${bid ? `&bid=${bid}` : ""}`,
  );
export const createDevPayment = ({
  amount,
  ri3,
}: {
  amount: string;
  ri3?: string;
}): AxiosPromise<{ status: number }> =>
  httpClient.get("/aaa/index?ri3=" + ri3 + "&amount=" + amount);

export const getChangeInfoParams = () =>
  httpClient.get("/business/changeInfoForm");
export type TChangeInfoParams = {
  row: {
    m01_id: number;
    m01_e03_id: number;
    m01_username: string;
    m01_email: string;
    m01_passwordhashed: string;
    m01_salt: string;
    m01_afm: string;
    m01_lastname: string;
    m01_firstname: string;
    m01_phone: string;
    m01_isenabled: boolean;
    m01_registrationdate: string;
    m01_lastlogindate: string;
    m01_isfromchamber: boolean;
    m01_ispubliccomp: null | string;
    M01_DATE_CREATED: null | string;
    M01_LAST_UPDATED: string;
    m01_iban: string;
    m01_mobilephone: null | string;
  };
};

export const submitChangeInfo = (data: {
  m01_iban: string | undefined | null;
  m01_phone: string;
  m01_firstname: string;
  m01_lastname: string;
  m01_email: string;
  m01_username: string;
}) => {
  const formData = new FormData();
  formData.append("m01_username", data.m01_username);
  formData.append("m01_email", data.m01_email);
  formData.append("m01_lastname", data.m01_lastname);
  formData.append("m01_firstname", data.m01_firstname);
  formData.append("m01_phone", data.m01_phone);
  if (data.m01_iban) {
    formData.append("m01_iban", data.m01_iban);
  }
  return httpClient.post("/business/changeUserInfo", formData);
};

export const submitChangeInfoPwd = (data: {
  m01_password: string;
  m01_password1: string;
  m01_password2: string;
}) => {
  const formData = new FormData();
  formData.append("m01_password", data.m01_password);
  formData.append("m01_password1", data.m01_password1);
  formData.append("m01_password2", data.m01_password2);
  return httpClient.post("/business/changePwdInfo", formData);
};
export const getXbrlErrorMessages = (guid: string) =>
  httpClient.get(`/business/xbrlErrorMessages?guid=${guid}`);

export const getCompanyContactInfo = (): AxiosPromise<TCompanyContactInfo> =>
  httpClient.get("/business/changeCompanyInfoForm");
export type TCompanyContactInfo = {
  email: string;
  phone: string;
  mobile: string;
};

export const submitChangeCompanyContactInfo = (data: {
  email: string;
  phone: string;
  mobile: string;
}) => {
  const formData = new FormData();
  formData.append("email", data.email);
  formData.append("phone", data.phone);
  formData.append("mobile", data.mobile);
  return httpClient.post("/business/changeCompanyInfo", formData);
};

export const getDomesticBranchesParams =
  (): AxiosPromise<TDomesticBranchesParams> =>
    httpClient.get("/business/domesticBranches?hasDomesticBranches=true");

export const getDomesticBranches = (
  pagination: MRT_PaginationState,
): AxiosPromise<TGetDomesticBranchesResponse> => {
  const formData = new FormData();
  formData.append(
    "start",
    (pagination.pageIndex * pagination.pageSize).toString(),
  );
  formData.append("length", pagination.pageSize.toString());
  formData.append("columnsCount", "4");
  return httpClient.post("/business/domesticBranchesAsJSON", formData);
};
